import { ResizeAPI } from '@wix/thumbnail-generator';
import { isEditorX } from '../../utils/editorx';
export const defaultSettings = {
  apiUrl: 'https://publicmedia.wix.com/public',
  multiSearchApiUrl: isEditorX ? 'https://files.editorx.com' : 'https://files.wix.com',
  itemsLimit: 50,
  imageOperationsApi: ResizeAPI.Vanbrandt,
  filesUrl: 'https://static.wixstatic.com',
  videoFilesUrl: 'https://video.wixstatic.com',
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    thumbnailFit: {
      width: 210,
      height: 210,
      mode: 'fit'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  },
  videoPreviewQuality: '480p',
  wixUser: false
};